import { Price } from "./price.model";
import { TicketFee } from "./ticket-fee.model";
import { Money } from "./money.model";
import { Link } from "./link.model";
let uuid = require('uuid');

export class PriceLevel {
	public pos: number;
	public storageId: number;
	public name: string;
	public uuid: string;
	public price: Price;
	public maxAllowed: number;
	public ticketFees: TicketFee[];
	public priceInclFees: Money;
	public hideOnline: boolean;
	public forSponsors: boolean;
	public voucherNeeded: boolean;
	public _links: {
		self: Link
		deleteWithReference: Link
	}

	public static create(): PriceLevel {
		let priceLevel = new PriceLevel();
		priceLevel.pos = null;
		priceLevel.uuid = uuid.v4();
		priceLevel.price = new Price();
		priceLevel.price.money = new Money();
		priceLevel.price.money.currency = "EUR";
		priceLevel.ticketFees = [];
		priceLevel.price.vat = null;
		priceLevel.hideOnline = false;
		priceLevel.forSponsors = false;
		priceLevel.maxAllowed = null;
		priceLevel.voucherNeeded = false;
		return priceLevel;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/pricelevel.model.ts